import { connect } from 'react-redux'
import React from 'react'
import { Dialog } from 'antd-mobile'
import iconSuccess from '../../../assets/xiniu/integral_success_icon.png'
import { handleCatch, postMessage } from '../../../utils'
import { requestIntegralData } from '../../../actions/integralAction'
import PropTypes from 'prop-types'
import { withTranslation } from 'react-i18next'
import classnames from 'classnames'

class IntegralList1Item extends React.PureComponent {
  static propTypes = {
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    onButtonClick: PropTypes.func
  }
  static defaultProps = {
    value: '-',
    title: '',
    text: '',
    extend: '',
    buttonText: '兑换'
  }

  render () {
    const {
      value, text, extend, buttonText, onButtonClick, contract,
      type
    } = this.props
    let { title } = this.props
    let titleEx = ''
    // let valueClass = `integral-list__value integral-list__value--${type}`
    let valueClass = classnames(`integral-list__value integral-list__value--${type}`, {
      [`integral-list__value--${contract}`]: contract
    })
    try {
      title = title.replaceAll('（', '(')
      title = title.replaceAll('）', ')')
      if (title.match('(套装)')) {
        title = title.replace('(套装)', '')
        titleEx = ('(套装)')
      }
    } catch (e) {
      console.error(e.message)
    }
    return <div className="integral-list__item">
      <div className={valueClass}>
        &#165;<span>{value}</span>
      </div>
      <div className="integral-list__main">
        <div className="integral-list__title">{title}<span>{titleEx}</span></div>
        <div className="integral-list__text">{text}</div>
        <div className="integral-list__extend">{extend}</div>
      </div>
      <div className="integral-list__button" onClick={onButtonClick}>{buttonText}</div>
    </div>
  }

}

@withTranslation()
class RenderModal extends React.PureComponent {
  static propTypes = {
    visible: PropTypes.bool,
    title: PropTypes.string,
    value: PropTypes.string,
    onConfirmCancel: PropTypes.func,
    onConfirmSubmit: PropTypes.func,
  }

  render () {
    const { t, visible, title, value, onConfirmCancel, onConfirmSubmit } = this.props
    return <Dialog
      visible={visible}
      title={title}
      closeOnMaskClick={false}
      actions={[[{
        key: 'cancel',
        text: t('common.cancel'),
        onClick: onConfirmCancel,
        danger: false,
      }, {
        key: 'submit',
        text: t('integral.block_3_button'),
        bold: true,
        danger: true,
        onClick: onConfirmSubmit
      }]]}
      content={<div style={{ textAlign: 'center', fontSize: 'larger' }}>
        <div>{value}{t('unit.points')}</div>
        <div>{t('integral.modal_text')}</div>
      </div>}
    />
  }
}

@withTranslation()
@connect(state => {
  return {
    store: {
      listData: state.integralList.listData
    }
  }
})
class IntegralList extends React.PureComponent {
  state = {
    modalVisible: false,
    pendingData: {},
    confirmVisible: false
  }

  render () {
    const { t } = this.props
    const { listData } = this.props.store
    const { confirmVisible, pendingData } = this.state
    return <div>
      <div className="integral-list">
        {
          listData.map(item => {
            return <IntegralList1Item
              key={item['id']}
              value={item['value'] || '-'}
              title={item['title']}
              text={`${item['integral']}${t('unit.points')}`}
              extend={item['sales'] ? `${item['sales']}${t('integral.list_text')}` : ''}
              contract={item['contract']}
              type={item['type']}
              buttonText={t('integral.block_3_button')}
              onButtonClick={this.onItemClick.bind(this, item)}
            />
          })
        }
      </div>
      <RenderModal
        visible={confirmVisible}
        title={pendingData['title']}
        value={pendingData['integral']}
        onConfirmSubmit={this.onConfirmSubmit}
        onConfirmCancel={this.onConfirmCancel}
      />
      {/*<Modal*/}
      {/*  visible={confirmVisible}*/}
      {/*  transparent*/}
      {/*  title={pendingData['title']}*/}
      {/*  maskClosable={false}*/}
      {/*  footer={[{*/}
      {/*    text: '取消', onPress: this.onConfirmCancel*/}
      {/*  }, {*/}
      {/*    text: '兑换', onPress: this.onConfirmSubmit*/}
      {/*  }]}*/}
      {/*  wrapProps={{ onTouchStart: handleWrapTouchStart }}*/}
      {/*>*/}
      {/*  <div style={{ textAlign: 'center', fontSize: 'larger' }}>*/}
      {/*    <div>{pendingData['integral']}积分</div>*/}
      {/*    <div>兑换 1 张</div>*/}
      {/*  </div>*/}
      {/*</Modal>*/}
    </div>
  }

  onItemClick = (item) => {
    this.setState({
      pendingData: { ...item },
      confirmVisible: true
    })
  }
  onConfirmSubmit = () => {
    const { pendingData } = this.state
    if (!pendingData['id']) {
      console.warn(`pendingData['id'] is ${pendingData['id']}`)
      window.toast.fail('数据错误，兑换失败', 2)
      return
    }
    this.postIntegral(pendingData['id'])
  }
  onConfirmCancel = () => {
    this.setState({
      confirmVisible: false
    })
  }
  postIntegral = (id, count = 1) => {
    const { t } = this.props
    let config = {
      method: 'post',
      url: window.API.Integral.postIntegralTicket(id, count)
    }
    window.toast.show('')
    window.axios.request(config)
      .then(() => {
        window.toast.hide()
        this.setState({ confirmVisible: false }, () => {
          (process.env['REACT_APP_CHANNEL'] === 'haiou')
            ? Dialog.alert({
              title: t('integral.modal_success'),
              confirmText: t('common.ok')
            })
            : Dialog.confirm({
              content: <div className={'leading-normal text-2xl font-bold text-center'}>
                <img className={'w-6 flex-shrink-0 inline-block'} src={iconSuccess} alt=""/>&nbsp;
                <div className={'inline-block'}>{t('integral.modal_success')}</div>
              </div>,
              cancelText: t('common.back'),
              confirmText: t('common.order'),
              onConfirm: () => {
                postMessage({
                  type: window.POST_TYPE.BUY,
                  data: {
                    extMap: {
                      productId: this.state.pendingData['productId'],
                      contract: this.state.pendingData['contract'],
                    }
                  }
                })
              },
            })
              .then()
          this.props.dispatch(requestIntegralData())
        })
        // })
      })
      .catch((e) => {
        if (e.message.match('兑换数量已满')) {
          this.setState({ confirmVisible: false }, () => {
            window.toast.hide()
            Dialog.confirm({
              title: <div><span className={'text-red-600'}>此券今日暂被兑罄</span><br/>明日请尽早兑换</div>,
              content: <div className={'text-zinc-500 text-center'}>先看看其他券吧</div>,
              confirmText: '兑其他券'
            }).then()
          })
        } else if (e.message.match('库存确认中')) {
          this.setState({ confirmVisible: false }, () => {
            window.toast.hide()
            Dialog.alert({
              title: '库存确认中',
              content: '若库存充足，系统会自动发放相应优惠卷；若库存不足，系统会自动返还积分。如有疑问，请联系在线客服。',
              confirmText: '确认'
            }).then()
          })
        } else if (e.message.match('心碎一地')) {
          let { star: start, end } = JSON.parse(e.message)
          this.setState({ confirmVisible: false }, () => {
            window.toast.hide()
            Dialog.alert({
              title: '心碎一地，来得不是时候',
              content: `活动时间${start}至${end}，等你哦`,
              confirmText: '知道了'
            }).then()
          })
        } else {
          handleCatch(e)
        }
      }).finally(() => this.setState({ confirmVisible: false }))
  }
}

export default IntegralList
